module.exports = __webpack_public_path__ + "img/img01.c29ea5ab.png";